module.exports = __webpack_public_path__ + "static/img/passion-05.4e9fc17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/passion-05.png
// module id = 130
// module chunks = 0